__turbopack_context__.v({
  "className": "gjO1mW_className",
  "variable": "gjO1mW_variable",
});
